import { useCallback, useEffect } from 'react';
export var toggleBodyOverflow = function (action, disableBackdrop) {
    if (disableBackdrop)
        return;
    document.body.style.overflow = action === 'open' ? 'hidden' : 'auto';
};
export var useDropdownToggle = function (_a) {
    var node = _a.node, isOpen = _a.isOpen, onToggle = _a.onToggle, disableBackdrop = _a.disableBackdrop;
    var onOpen = useCallback(function () {
        toggleBodyOverflow('open', disableBackdrop);
        typeof onToggle === 'function' && onToggle(true);
        // eslint-disable-next-line
    }, [onToggle]);
    var onClose = useCallback(function () {
        toggleBodyOverflow('close', disableBackdrop);
        typeof onToggle === 'function' && onToggle(false);
        // eslint-disable-next-line
    }, [onToggle]);
    var handleClickOutside = useCallback(function (e) {
        var currentNode = (node && node.current);
        if (currentNode.contains(e.target)) {
            return;
        }
        onClose();
    }, [node, onClose]);
    useEffect(function () {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('keydown', handleClickOutside);
        }
        else {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleClickOutside);
        }
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleClickOutside);
        };
    }, [isOpen, handleClickOutside]);
    return {
        onOpen: onOpen,
        onClose: onClose
    };
};
//# sourceMappingURL=useDropdownToggle.js.map